/* ABOUT US：RPG風の文字送り / 自動スライド / 画面クリックで次へ / 離れたら1章目に戻す */
(function () {
  'use strict';
  if (window.__mxAboutExtra) return;
  window.__mxAboutExtra = true;

  var reduce = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

  function toPlain(html) {
    var d = document.createElement('div');
    d.innerHTML = html.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n').replace(/<p[^>]*>/gi, '');
    return (d.textContent || '').replace(/\n{3,}/g, '\n\n').replace(/^\n+|\n+$/g, '');
  }

  function init(sec) {
    if (sec.dataset.mxAboutExtra === '1') return;
    sec.dataset.mxAboutExtra = '1';

    var wrap = sec.querySelector('.mx-chapters');
    if (!wrap) return;
    var chapters = Array.prototype.slice.call(wrap.children);
    if (!chapters.length) return;
    var dots = sec.querySelectorAll('.mx-dots i');

    var speed = parseInt(sec.getAttribute('data-type-speed'), 10);
    if (isNaN(speed)) speed = 35;
    var autoSec = parseInt(sec.getAttribute('data-autoplay'), 10);
    if (isNaN(autoSec)) autoSec = 20;

    chapters.forEach(function (ch) {
      var body = ch.querySelector('.mx-msg__body');
      if (body) body.dataset.full = toPlain(body.innerHTML);
    });

    var timer = null;
    var autoTimer = null;
    var inView = false;
    var last = -1;

    function index() { return Math.round(wrap.scrollLeft / wrap.clientWidth); }
    function stopTyping() { if (timer) { clearInterval(timer); timer = null; } }

    function finish(ch) {
      stopTyping();
      var body = ch.querySelector('.mx-msg__body');
      if (body) body.textContent = body.dataset.full || '';
      ch.classList.remove('is-typing');
      ch.classList.add('is-done');
    }

    function type(ch) {
      stopTyping();
      chapters.forEach(function (c) { c.classList.remove('is-typing', 'is-done'); });
      var body = ch.querySelector('.mx-msg__body');
      if (!body) return;
      var full = body.dataset.full || '';
      if (!speed || reduce()) { finish(ch); return; }
      body.textContent = '';
      ch.classList.add('is-typing');
      var i = 0;
      timer = setInterval(function () {
        i++;
        body.textContent = full.slice(0, i);
        if (i >= full.length) finish(ch);
      }, speed);
    }

    function syncDots() {
      var i = index();
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }

    function goTo(i, instant) {
      var n = chapters.length;
      if (i < 0) i = n - 1;
      if (i > n - 1) i = 0;
      wrap.scrollTo({ left: i * wrap.clientWidth, behavior: (instant || reduce()) ? 'auto' : 'smooth' });
      restartAuto();
    }
    function next() { goTo(index() + 1); }

    function restartAuto() {
      if (autoTimer) clearInterval(autoTimer);
      if (!autoSec) return;
      autoTimer = setInterval(function () { if (inView) next(); }, autoSec * 1000);
    }

    function onScroll() {
      var i = index();
      if (i === last) return;
      last = i;
      syncDots();
      if (chapters[i]) type(chapters[i]);
      restartAuto();
    }
    wrap.addEventListener('scroll', function () { requestAnimationFrame(onScroll); }, { passive: true });

    var panel = sec.querySelector('.mx-panel');
    if (panel) {
      panel.addEventListener('click', function () {
        var ch = chapters[index()];
        if (!ch) return;
        if (ch.classList.contains('is-typing')) finish(ch);
        else next();
      });
    }

    sec.querySelectorAll('.mx-arrow, .mx-dots i').forEach(function (el) {
      el.addEventListener('click', function () { restartAuto(); });
    });

    /* セクションを離れたら 1章目にリセット */
    function reset() {
      stopTyping();
      if (autoTimer) clearInterval(autoTimer);
      wrap.scrollTo({ left: 0, behavior: 'auto' });
      last = 0;
      syncDots();
      chapters.forEach(function (c) { c.classList.remove('is-typing', 'is-done'); });
      var b = chapters[0] && chapters[0].querySelector('.mx-msg__body');
      if (b) b.textContent = '';
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          inView = en.isIntersecting;
          if (inView) {
            last = 0;
            wrap.scrollLeft = 0;
            syncDots();
            if (chapters[0]) type(chapters[0]);
            restartAuto();
          } else {
            reset();
          }
        });
      }, { threshold: 0.4 });
      io.observe(sec);
    } else {
      type(chapters[0]);
      restartAuto();
    }
  }

  function boot() { document.querySelectorAll('[data-mx-about]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
